var React = require('react');

function ChevronDown (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M.5 1C.5.7.6.5.8.3c.4-.4 1-.4 1.4 0l5.3 5.3L12.8.3c.4-.4 1-.4 1.4 0 .4.4.4 1 0 1.4l-6 6c-.4.4-1 .4-1.4 0l-6-6C.6 1.5.5 1.3.5 1z"}));
}

ChevronDown.defaultProps = {"viewBox":"0 0 15 8"};

module.exports = ChevronDown;

ChevronDown.default = ChevronDown;
